import type { JiraCreateItemsAction } from '@atlassian/rovo-content-bridge-api-commands/commands/jira-create-items-command';

import type { DraftWorkItem } from '../common/types';

/**
 * Converts a flat map or array of `DraftWorkItem` objects into an array of `JiraCreateItemsAction` data objects.
 *
 * - Removes the `issuetype` field from fields object as it's already captured in `issueTypeId`
 * - Preserves all other fields including parent references
 *
 * @param draftWorkItems - Map of DraftWorkItem objects
 * @returns Array of JiraCreateItemsAction data objects
 */
export const toJiraCreateItems = (
	draftWorkItems: Record<string, DraftWorkItem>,
): JiraCreateItemsAction['data'][] => {
	const items = Object.values(draftWorkItems).filter(
		(workItem) => workItem.status !== 'cancelled' && !workItem.createdIssueKey,
	);

	return items.map((item) => {
		const { issuetype: _issuetypeIgnored, ...fieldsWithoutIssuetype } = item.fields;

		return {
			projectIdOrKey: item.projectIdOrKey,
			issueTypeId: item.issueTypeId,
			summary: item.summary,
			fields: fieldsWithoutIssuetype,
		};
	});
};
